module.exports = __webpack_public_path__ + "img/17_70.78eed876.png";